module.exports = __webpack_public_path__ + "img/20180404_171457-1.96b54d1f.jpg";